/** Display formatting only: requests retain their exact internal references. */
export function assistantDisplayText(value: string): string {
  if (/^(?:Review BOQ|Show) pricing draft /.test(value)) return 'Review pricing draft';
  if (value.startsWith('Review BOQ pricing run ')) return 'Review and apply priced lines';
  return value.replace(/\b[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}\b/gi,'this item')
    .replace(/\b(?:quantisai_[a-z_]+|boq-\d{10,})\b/g,'QuantisAI');
}
export function agentDisplayName(runId:string):string {
  const first=['Alex','Casey','Jamie','Morgan','Riley','Sam','Taylor','Jordan','Charlie','Avery','Robin','Drew','Cameron','Blake','Ellis','Quinn'];
  const last=['Reed','Clarke','Hayes','Brooks','Parker','Bennett','Ellis','Shaw','Ward','Foster','Gray','Wells','Bell','Grant','Lane','Cole'];
  let hash=0;for(const character of runId.toLowerCase()) hash=(Math.imul(hash,31)+character.charCodeAt(0))>>>0;
  return `${first[hash%first.length]} ${last[Math.floor(hash/first.length)%last.length]}`;
}
export function agentDisplayTitle(job:{role:string;task:string}):string {
  if(job.role==='quantisai_pricing') return 'Preparing pricing';
  if(job.role==='quantisai_takeoff') return job.task.replace(/^Take off (.+?), page (\d+)\..*$/s,'Measuring $1, page $2');
  if(job.task.startsWith('Research verified unit rates for ONLY these BOQ item IDs:')) return 'Researching unit rates';
  return assistantDisplayText(job.task);
}
export function agentDisplayReport(value:string):string {
  const fenced=/```json\s*([\s\S]*?)```/.exec(value);
  let report:Record<string,unknown>;
  try{report=JSON.parse(fenced?.[1]??value);}catch{return assistantDisplayText(value);}
  if(!report||typeof report!=='object'||!['matches','buildUps','unresolved'].some(key=>key in report)) return assistantDisplayText(value);
  const sections:string[]=[];
  for(const [key,heading] of [['matches','Library rates'],['buildUps','Resource breakdowns'],['unresolved','Information needed']]){
    const rows=report[key];if(!Array.isArray(rows)||!rows.length) continue;
    const lines=rows.flatMap(row=>{
      if(!row||typeof row.reason!=='string') return [];
      const assumptions=Array.isArray(row.assumptions)?row.assumptions.filter((a:unknown):a is string=>typeof a==='string'):[];
      return [`- ${assistantDisplayText(row.reason)}${assumptions.length?'\n  Assumptions: '+assumptions.map(assistantDisplayText).join('; '):''}`];
    });
    if(lines.length) sections.push(`${heading}\n${lines.join('\n\n')}`);
  }
  return sections.join('\n\n')||'Research finished. Review the pricing draft for details.';
}
